module.exports = __webpack_public_path__ + "static/media/mac-800_500.b9c8d421.jpg";